import { c as _c } from "react-compiler-runtime";
import { registerQuery, useQuery } from 'data-fetching-client';
import userInfoHubHttp from 'hub-http/userInfo';
import { gateOverrides, scopeOverrides } from 'collaboration-sidebar-common/features/devtools/overrides';
import { isInternalEmail } from 'collaboration-sidebar-common/features/devtools/utils';
const buildAccessCheck = (validKeys, keys) => {
  const knownKeys = new Set(validKeys);
  const result = new Set();
  for (const key of keys) {
    if (knownKeys.has(key)) {
      result.add(key);
    }
  }
  return result;
};
export const COLLABORATION_SIDEBAR_GATES = [];
const SCOPES_FOR_SUPPORTED_HUBS = {
  MARKETING_HUB: 'commenting-access-marketing-hub',
  SERVICE_HUB: 'commenting-access-service-hub',
  CMS_HUB: 'commenting-access-cms-hub',
  OPS_HUB: 'commenting-access-ops-hub',
  SALES_HUB: 'commenting-access-sales-hub'
};
export const COLLABORATION_SIDEBAR_SCOPES = ['ads-read', 'blog-write', 'calendar-access', 'campaigns-access', 'campaigns-write', 'commenting-access-cms-hub', 'commenting-access-marketing-hub', 'commenting-access-ops-hub', 'commenting-access-sales-hub', 'commenting-access-service-hub', 'email-write', 'landingpages-write', 'marketing-tasks-write', 'pages-write', 'teams-advanced-modeling-access'];
const USER_INFO_QUERY = registerQuery({
  args: [],
  fieldName: 'collaborationSidebarUserInfo',
  fetcher: async () => {
    const userInfoResponse = await userInfoHubHttp();
    return Object.assign({}, userInfoResponse, {
      gatesForUser: buildAccessCheck(COLLABORATION_SIDEBAR_GATES, userInfoResponse.gates || []),
      scopesForUser: buildAccessCheck(COLLABORATION_SIDEBAR_SCOPES, userInfoResponse.user.scopes)
    });
  }
});
export const useUserInfo = () => {
  "use memo";

  var _data$collaborationSi, _data$collaborationSi4, _data$collaborationSi8;
  const $ = _c(17);
  const {
    data,
    loading: userInfoLoading,
    error: userInfoError
  } = useQuery(USER_INFO_QUERY);
  let t0;
  if ($[0] !== (data === null || data === void 0 || (_data$collaborationSi = data.collaborationSidebarUserInfo) === null || _data$collaborationSi === void 0 || (_data$collaborationSi = _data$collaborationSi.user) === null || _data$collaborationSi === void 0 ? void 0 : _data$collaborationSi.email)) {
    var _data$collaborationSi3;
    t0 = () => {
      var _data$collaborationSi2;
      const email = data === null || data === void 0 || (_data$collaborationSi2 = data.collaborationSidebarUserInfo) === null || _data$collaborationSi2 === void 0 || (_data$collaborationSi2 = _data$collaborationSi2.user) === null || _data$collaborationSi2 === void 0 ? void 0 : _data$collaborationSi2.email;
      return !!email && isInternalEmail(email);
    };
    $[0] = data === null || data === void 0 || (_data$collaborationSi3 = data.collaborationSidebarUserInfo) === null || _data$collaborationSi3 === void 0 || (_data$collaborationSi3 = _data$collaborationSi3.user) === null || _data$collaborationSi3 === void 0 ? void 0 : _data$collaborationSi3.email;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isInternalUser = t0;
  let t1;
  if ($[2] !== (data === null || data === void 0 || (_data$collaborationSi4 = data.collaborationSidebarUserInfo) === null || _data$collaborationSi4 === void 0 ? void 0 : _data$collaborationSi4.gatesForUser) || $[3] !== isInternalUser) {
    var _data$collaborationSi7;
    t1 = gateToCheck => {
      var _data$collaborationSi5, _data$collaborationSi6;
      if (isInternalUser()) {
        const override = gateOverrides.get(gateToCheck);
        if (override !== null) {
          return override;
        }
      }
      return (_data$collaborationSi5 = data === null || data === void 0 || (_data$collaborationSi6 = data.collaborationSidebarUserInfo) === null || _data$collaborationSi6 === void 0 ? void 0 : _data$collaborationSi6.gatesForUser.has(gateToCheck)) !== null && _data$collaborationSi5 !== void 0 ? _data$collaborationSi5 : false;
    };
    $[2] = data === null || data === void 0 || (_data$collaborationSi7 = data.collaborationSidebarUserInfo) === null || _data$collaborationSi7 === void 0 ? void 0 : _data$collaborationSi7.gatesForUser;
    $[3] = isInternalUser;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const hasGate = t1;
  let t2;
  if ($[5] !== (data === null || data === void 0 || (_data$collaborationSi8 = data.collaborationSidebarUserInfo) === null || _data$collaborationSi8 === void 0 ? void 0 : _data$collaborationSi8.scopesForUser) || $[6] !== isInternalUser) {
    var _data$collaborationSi11;
    t2 = scopeToCheck => {
      var _data$collaborationSi9, _data$collaborationSi10;
      if (isInternalUser()) {
        const override_0 = scopeOverrides.get(scopeToCheck);
        if (override_0 !== null) {
          return override_0;
        }
      }
      return (_data$collaborationSi9 = data === null || data === void 0 || (_data$collaborationSi10 = data.collaborationSidebarUserInfo) === null || _data$collaborationSi10 === void 0 ? void 0 : _data$collaborationSi10.scopesForUser.has(scopeToCheck)) !== null && _data$collaborationSi9 !== void 0 ? _data$collaborationSi9 : false;
    };
    $[5] = data === null || data === void 0 || (_data$collaborationSi11 = data.collaborationSidebarUserInfo) === null || _data$collaborationSi11 === void 0 ? void 0 : _data$collaborationSi11.scopesForUser;
    $[6] = isInternalUser;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const hasScope = t2;
  let t3;
  if ($[8] !== hasScope) {
    t3 = hub => hasScope(SCOPES_FOR_SUPPORTED_HUBS[hub]);
    $[8] = hasScope;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const hasScopeForHub = t3;
  const t4 = data === null || data === void 0 ? void 0 : data.collaborationSidebarUserInfo;
  let t5;
  if ($[10] !== hasGate || $[11] !== hasScope || $[12] !== hasScopeForHub || $[13] !== t4 || $[14] !== userInfoError || $[15] !== userInfoLoading) {
    t5 = {
      userInfo: t4,
      userInfoLoading,
      userInfoError,
      hasGate,
      hasScope,
      hasScopeForHub
    };
    $[10] = hasGate;
    $[11] = hasScope;
    $[12] = hasScopeForHub;
    $[13] = t4;
    $[14] = userInfoError;
    $[15] = userInfoLoading;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};